import * as React from "react"
import * as ReactDOM from "react-dom"
import { Moment } from 'moment';
import * as moment from 'moment';

import { RentalAdvertPricing } from '../../../types/types'

import Summary from '../../../advert_detail/booking_form/mobile/summary'
import PeriodSelection from '../../../advert_detail/booking_form/mobile/period_selection'
import { StartEnd } from '../../../utils/period_picker/PeriodPicker'
import * as PeriodEventEmitter from '../../../utils/period_picker/PeriodEventEmitter'
import * as PeopleEventEmitter from '../../../utils/period_picker/PeopleEventEmitter'
import IsSameMoment from '../../../utils/IsSameMoment'

import { FocusedInputShape } from 'react-dates';
import * as Api from '../../../api/fetch'

type Props = {
  advert_id: number
  arrival_date: Moment
  departure_date: Moment
  max_people_select: number
  max_people: string
}

type State = {
  pricing: RentalAdvertPricing
  period_open: boolean
  arrival_date: Moment
  departure_date: Moment
  max_people: number
  focusedInput: FocusedInputShape

}

export default class MobilePeriodSelection extends React.Component<Props, State> {
  subscriptionToken: string
  peopleSubscriptionToken: string
  constructor(props : Props, context) {
    super(props, context)
    this.state = {
      pricing: null,
      period_open: false,
      arrival_date: this.props.arrival_date ? moment(this.props.arrival_date, "DD-MM-YYYY") : null,
      departure_date: this.props.departure_date ? moment(this.props.departure_date,   "DD-MM-YYYY") : null,
      max_people: parseInt(this.props.max_people) || 1,
      focusedInput: null,
    }
  }

  async refresh() {
    const pricing = await Api.fetchPricing(this.props.advert_id, this.state.arrival_date, this.state.departure_date, this.state.max_people)
    this.setState({
      ...this.state,
      pricing: pricing
    })
  }

  componentDidMount() {
    this.refresh()
  }

  componentWillMount() {

    this.subscriptionToken = PeriodEventEmitter.subscribe((payload: PeriodEventEmitter.EventPayload) => {
      const arrival_date = payload.start_date
      const departure_date = payload.end_date

      if (!IsSameMoment(this.state.arrival_date, payload.start_date) || !IsSameMoment(this.state.departure_date, payload.end_date)) {
        this.setState({ arrival_date: arrival_date, departure_date: departure_date })
      }
    })
    this.peopleSubscriptionToken = PeopleEventEmitter.subscribe((payload: PeopleEventEmitter.EventPayload) => {
      if (payload.max_people != this.state.max_people) {
        this.setState({ max_people: payload.max_people })
      }
    })
  }

  componentWillUnmount() {
    PeriodEventEmitter.unsubscribe(this.subscriptionToken)
    PeopleEventEmitter.unsubscribe(this.peopleSubscriptionToken)
  }

  componentDidUpdate(prevProps : Props, prevState : State) {
    if (this.shouldRefreshPricing(prevProps, prevState)) {
      this.refresh()
    }
  }

  shouldRefreshPricing(prevProps : Props, prevState : State) {
    return (
      prevProps.advert_id !== this.props.advert_id ||
      prevState.arrival_date !== this.state.arrival_date ||
      prevState.departure_date !== this.state.departure_date ||
      prevState.max_people !== this.state.max_people)
  }

  togglePeriodSelection() {
    this.setState({...this.state, period_open: !this.state.period_open })
  }

  render() {
    return (
      <div className="conversion-box">
        <div className={`conversion-box__period-selection ${this.state.period_open ? '' : 'closed'}`}>
          <PeriodSelection
            arrival_date={this.state.arrival_date}
            departure_date={this.state.departure_date}
            advert_id={this.props.advert_id}
            onDatesChange={(range: StartEnd) => this.setState({ arrival_date: range.startDate, departure_date: range.endDate })}
            max_people_select={this.props.max_people_select}
            max_people={this.state.max_people}
            onMaxPeopleChange={(value:number) => this.setState({ max_people: value})}
            closeScreen={() => this.togglePeriodSelection()}
            focusedInput={this.state.focusedInput}
            onFocusChange={(fi) => this.setState({focusedInput: fi})}
            pricing={this.state.pricing}
          />
        </div>
        <Summary
          pricing={this.state.pricing}
          onPriceClick={() => this.togglePeriodSelection()}
        />
      </div>
    )
  }
}
